<template>
  <div class="sidebar" v-if="emails">
    <EmailSidebarItem
      v-for="email in emails"
      :key="email.id"
      :selected="selected === email.id"
      :read="read.includes(email.id) || email.read"
      :tag="email.tag"
      :emailId="email.id"
      :emailTitle="email.subject"
      :emailContent="email.body"
      @click="onItemClick"
    />
  </div>
</template>

<script>
import EmailSidebarItem from "./EmailSidebarItem";

export default {
  name: "EmailSidebar",
  components: { EmailSidebarItem },
  props: { emails: Array },
  data() {
    return {
      read: [],
      selected: undefined,
    };
  },
  methods: {
    onItemClick(emailId) {
      this.selected = emailId;
      this.read.push(emailId);
      this.$emit("itemClick", emailId);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/mixins";

.sidebar {
  @include style-scrollbars(rgba(black, 0.4), white);

  max-width: 280px;
  height: 100%;
  flex: 1;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  background-color: white;

  border-right: 1px solid grey;

  overflow: auto;
}
</style>
